import React from 'react';
import './RawResponseModal.css';

const RawResponseModal = ({ isOpen, onClose, rawResponse }) => {
  if (!isOpen || !rawResponse) return null;

  // Format JSON for better readability
  let formattedResponse = '';
  try {
    // Handle both string and object types
    const parsed = typeof rawResponse === 'string' ? JSON.parse(rawResponse) : rawResponse;
    formattedResponse = JSON.stringify(parsed, null, 2);
  } catch (e) {
    // If not valid JSON, stringify the value as-is
    formattedResponse = typeof rawResponse === 'string' ? rawResponse : JSON.stringify(rawResponse, null, 2);
  }

  return (
    <div className="raw-response-modal-overlay" onClick={onClose}>
      <div className="raw-response-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="raw-response-modal-header">
          <h3>Raw API Response</h3>
          <button className="raw-response-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="raw-response-modal-body">
          <pre className="raw-response-modal-json">
            {formattedResponse}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default RawResponseModal;